export default __webpack_public_path__ + "static/media/eye.b5d6b5e5.svg";